import { Lock } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

import { INSTALL_STATUS_LABELS, RESULT_STATUS_LABELS } from '../constants';
import type { AgentAccessScope, AgentInstallStatus, AgentResultStatus } from '../types';

/** Colour-coded pill for an install's lifecycle state. */
export function InstallStatusBadge({ status }: { status: AgentInstallStatus }) {
  if (status === 'active') return <Badge className="bg-emerald-600">{INSTALL_STATUS_LABELS.active}</Badge>;
  if (status === 'paused')
    return (
      <Badge className="bg-amber-500 text-white">{INSTALL_STATUS_LABELS.paused}</Badge>
    );
  return <Badge variant="secondary">{INSTALL_STATUS_LABELS.draft}</Badge>;
}

/** A small lock shown for private (members-scoped) agents — nothing for public. */
export function PrivateLock({
  scope,
  className,
}: {
  scope: AgentAccessScope;
  className?: string;
}) {
  if (scope !== 'members') return null;
  return (
    <span title="Private — only selected members" className="inline-flex">
      <Lock className={cn('text-muted-foreground size-3.5', className)} aria-label="Private" />
    </span>
  );
}

/** Colour-coded pill for a produced result's state. */
export function ResultStatusBadge({ status }: { status: AgentResultStatus }) {
  if (status === 'posted') return <Badge className="bg-emerald-600">{RESULT_STATUS_LABELS.posted}</Badge>;
  if (status === 'final') return <Badge variant="outline">{RESULT_STATUS_LABELS.final}</Badge>;
  return <Badge variant="secondary">{RESULT_STATUS_LABELS.draft}</Badge>;
}
